import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import { prepareNum, unitLabel } from '@services/helper.service';
import { APP_TEXTS } from '../../../../../texts/texts';

import './../styles.scss';

class ResultsOfDesignAnnexC_AS extends React.Component {

	constructor(props) {
		super(props);

		this.prepareValue = props.prepareValue;
	}

	render() {
		return (
		<div className="calculation">
				{this.props.selectedItem && (
				<section className="list-type calculate-results-of-design">
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_TENSION.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>N</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_CONE_FAILURE.Content}</span>
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_N.Content}<sub>Rd,c</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.NRdc)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_ConcreteConeFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_SPLITTING_FAILURE.Content}</span>
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_N.Content}<sub>Rd,sp</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.NRdsp)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_SplittingFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_STEEL_FAILURE.Content}</span>
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_N.Content}<sub>Rd,s</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.NRds)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_SteelFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_PULL_OUT_FAILURE.Content}</span>
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_N.Content}<sub>Rd,p</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.NRdp)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_PullOutFailure, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
		
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_HEADER_SHEAR.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>V</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESGIN_EDGE_FAILURE.Content}</span>
										<span>V<sub>Rd,c</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.VRdc)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_ConcreteEdgeFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESGIN_PRYOUT_FAILURE.Content}</span>
										<span>V<sub>Rd,cp</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.VRdcp)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_PryoutFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_STEEL_FAILURE.Content}</span>
										<span>V<sub>Rd,s</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.VRds)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_SteelFailure, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
		
				<Table bordered size="sm">
					<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESGIN_UTILIZATION_EQUATION.Content}</span>
										{this.props.selectedItem.BetaN > 0 && this.props.selectedItem.BetaV <= 0 ? (
											<span className="utilization">
												&beta;<sub>N</sub>&nbsp;=
											</span>
										) : (this.props.selectedItem.BetaN <= 0 && this.props.selectedItem.BetaV > 0 ? (
                      <span className="utilization">
                        &beta;<sub>V</sub>&nbsp;=
                      </span>
                    ) : (
                      <span className="utilization">
                        &beta;<sub>N</sub><sup>{this.props.selectedItem.Beta_PowerFactor || 1.5}</sup>
                        &nbsp;+&nbsp;&beta;<sub>V</sub><sup>{this.props.selectedItem.Beta_PowerFactor || 1.5}</sup>&nbsp;=
                      </span>
                    ))}
								</div>
								</th>
								<td>{prepareNum(this.props.selectedItem.Beta, true, 2, true)}</td>
						</tr>
					</tbody>
				</Table>
				</section>
				)}
		</div>
		);
	}
    
}

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedItem) {
    return {
      selectedItem: data.gridSelectedItem,
	  loadUnit: state.main.units.load,
	  designStandard: state.main.localization.designStandard
    };
  }

  return {};
};
  
const mapDispatch = dispatch => ({
});
  
export default connect(mapState, mapDispatch)(ResultsOfDesignAnnexC_AS);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateResultsOfDesign/components/ResultsOfDesignAnnexC_AS.js